import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as Sentry from "@sentry/react";
import GET from "./utils/GET";

if (GET("environment") !== "development") {
	Sentry.init({
		dsn: "https://14da6118fbe745bb86e4345995294423@o389934.ingest.sentry.io/5811839",
		environment: GET("environment"),
	});
}

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById("root")
);
